'use strict';

/**
 * Verifies if both Loadbee and Sovido containers have children to show or not the "Videos" section.
 * @returns {void}
 */
function showVideoSection() {
	$(document).ready(function () {
		var $videos = $('.videos');
		if ($videos.find('video').length) {
			$videos.removeClass('d-none');
		}
	});
}

module.exports = {
	showVideoSection: showVideoSection
};
